import React, { useContext, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Box from "@mui/material/Box";
import { AuthContext } from "../contexts/AuthContext";
import authService from "../services/auth.service";
import CircularIndeterminate from "../components/Loader.component";

const SESSION_BASE_URL = process.env.REACT_APP_SESSION_API_URL || "http://localhost:3005";

// Bridges a short URL (session-service) through the Dashboard's own live auth
// state, so the link always resolves as whoever is currently logged into the
// Dashboard on this browser — never an independent, possibly stale, token.
const ShortUrlBridge = () => {
  const { user } = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");

  useEffect(() => {
    if (!code) return;

    if (!user) {
      const returnTo = encodeURIComponent(`/short-url-bridge?code=${code}`);
      window.location.replace(`/login?returnTo=${returnTo}`);
      return;
    }

    const token = authService.getAccessToken();
    if (!token) {
      const returnTo = encodeURIComponent(`/short-url-bridge?code=${code}`);
      window.location.replace(`/login?returnTo=${returnTo}`);
      return;
    }

    window.location.replace(`${SESSION_BASE_URL}/${code}?token=${encodeURIComponent(token)}`);
  }, [user, code]);

  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <CircularIndeterminate size={60} />
    </Box>
  );
};

export default ShortUrlBridge;
